import { Box, Typography, Stack, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface AgentSpeakerBarProps {
  agentName: string;
  isSpeaking?: boolean;
}

export default function AgentSpeakerBar({ agentName, isSpeaking = false }: AgentSpeakerBarProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        bgcolor: alpha('#1a1a2e', 0.97),
        borderTop: '2px solid',
        borderColor: isSpeaking ? '#10b981' : '#3b82f6',
        px: 3,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backdropFilter: 'blur(8px)',
        transition: 'border-color 0.3s ease',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: '50%',
            bgcolor: isSpeaking ? '#10b981' : '#3b82f6',
            boxShadow: isSpeaking ? '0 0 8px #10b981' : 'none',
            animation: isSpeaking ? 'pulse 1s infinite' : 'none',
            '@keyframes pulse': {
              '0%': { opacity: 1, transform: 'scale(1)' },
              '50%': { opacity: 0.6, transform: 'scale(1.3)' },
              '100%': { opacity: 1, transform: 'scale(1)' },
            },
          }}
        />
        <Typography
          variant="body1"
          sx={{ color: 'white', fontWeight: 600, fontSize: '0.95rem' }}
        >
          Vous parlez avec{' '}
          <Box component="span" sx={{ color: '#60a5fa' }}>
            {agentName}
          </Box>{' '}
          · Agent
        </Typography>
        {isSpeaking && (
          <Chip
            label="Parle..."
            size="small"
            sx={{
              bgcolor: alpha('#10b981', 0.2),
              color: '#10b981',
              fontWeight: 600,
              fontSize: '0.75rem',
              height: 24,
            }}
          />
        )}
      </Stack>
    </Box>
  );
}
